import React, { useState, useEffect } from "react";
import FinoDmtService from "../../../services/FinoDmtService";
import SideBar from "../../../components/Sidebar";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";
import Swal from "sweetalert2";

const MerchantOnboardingStatus = () => {
  const [loading, setLoading] = useState(false);
  const [merchantStatus, setMerchantStatus] = useState(null);
  const [finoEkycStatus, setEkycStatus] = useState(null);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const [finoBCData, setFinoBCData] = useState(null);

  useEffect(() => {
    handleMerchantOnboardingStatus();
    handleFinoBcStatus();
  }, []);

  /* -------------------------------
      MERCHANT ONBOARDING STATUS
  -------------------------------- */
  const handleMerchantOnboardingStatus = async () => {
    if (loading) return;

    setLoading(true);
    setError(null);
    try {
      const result = await FinoDmtService.merchantOnboardStatus();

      if (!result.success) {
        setError(result.message || "Request failed!");
        Swal.fire("Oops!", result.message || "Request failed!", "error");
        return;
      }

      const res = result.data;

      if (res.status === "SUCCESS") {
        const respData = res.data;
        setMerchantStatus(respData?.merchant_status);
        setEkycStatus(respData?.fino_ekyc_status);
        setResponse(respData?.response);
      } else {
        setError(res.message || "Something went wrong");
        Swal.fire("Oops!", res.message || "Something went wrong", "error");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || error.message || "Network error";
      setError(errorMsg);
      Swal.fire("Oops!", errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  /* -------------------------------
      FINO BC STATUS
  -------------------------------- */
  const handleFinoBcStatus = async () => {
    if (loading) return;

    setLoading(true);
    setError(null);
    try {
      const result = await FinoDmtService.finoBcStatus();

      if (!result.success) {
        setError(result.message || "Request failed!");
        Swal.fire("Oops!", result.message || "Request failed!", "error");
        return;
      }

      const res = result.data;

      if (res.status === "SUCCESS") {
        setFinoBCData(res.data);
      } else {
        setError(res.message || "Something went wrong");
        Swal.fire("Oops!", res.message || "Something went wrong", "error");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || error.message || "Network error";
      setError(errorMsg);
      Swal.fire("Oops!", errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <LoadingScreen />}

      <div className="container-fluid mt-3">
        <div className="row">
          <SideBar />

          <div className="col-md-9 mb-3">
            {/* ---------------- MERCHANT STATUS CARD ---------------- */}
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title mb-4">Merchant Onboarding Status</h5>

                <div className="row justify-content-center">
                  <div className="col-md-8">
                    {error && !merchantStatus ? (
                      <div className="alert alert-danger" role="alert">
                        {error}
                      </div>
                    ) : (
                      <div className="status-info">
                        <div className="mb-3 p-3 border rounded">
                          <div className="row mb-2">
                            <div className="col-md-4 fw-bold">
                              Merchant Status:
                            </div>
                            <div className="col-md-8">
                              <span
                                className={`badge ${
                                  merchantStatus === "APPROVED"
                                    ? "bg-success"
                                    : merchantStatus === "PENDING"
                                      ? "bg-warning"
                                      : merchantStatus === "REJECTED"
                                        ? "bg-danger"
                                        : "bg-secondary"
                                }`}
                              >
                                {merchantStatus || "N/A"}
                              </span>
                            </div>
                          </div>

                          <div className="row mb-2">
                            <div className="col-md-4 fw-bold">
                              Fino E-KYC Status:
                            </div>
                            <div className="col-md-8">
                              <span
                                className={`badge ${
                                  finoEkycStatus === "VERIFIED"
                                    ? "bg-success"
                                    : "bg-warning"
                                }`}
                              >
                                {finoEkycStatus || "N/A"}
                              </span>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4 fw-bold">Response:</div>
                            <div className="col-md-8">{response || "N/A"}</div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* ---------------- FINO BC STATUS CARD ---------------- */}
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title mb-4">Fino BC Status</h5>

                <div className="row justify-content-center">
                  <div className="col-md-8">
                    {error && !finoBCData ? (
                      <div className="alert alert-danger" role="alert">
                        {error}
                      </div>
                    ) : (
                      <div className="status-info">
                        <div className="mb-3 p-3 border rounded">
                          <div className="row mb-2">
                            <div className="col-md-4 fw-bold">
                              FINO BC Status:
                            </div>
                            <div className="col-md-8">
                              <span
                                className={`badge ${
                                  finoBCData?.fino_bc_status === "VERIFIED"
                                    ? "bg-success"
                                    : finoBCData?.fino_bc_status === "PENDING"
                                      ? "bg-warning"
                                      : finoBCData?.fino_bc_status ===
                                          "REJECTED"
                                        ? "bg-danger"
                                        : "bg-secondary"
                                }`}
                              >
                                {finoBCData?.fino_bc_status || "N/A"}
                              </span>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4 fw-bold">Response:</div>
                            <div className="col-md-8">
                              {finoBCData?.response || "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* ---------------- END ---------------- */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantOnboardingStatus;
